import { Tooltip, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React, { useState } from 'react'

import { gregorianToJalaaliWithHourMinuteAndSecondAndMilisecond } from '../../../helpers/date'
import { getTranslate, lang } from '../../../localization'
import { Log } from '../../../types/auditLogs'
import StateBox from '../../AdminConfigLog/components/StateBox'
import StatusBox from '../../BookingList/StatusBox'
import ContentModal from '../ContentModal'
import ResultModal from '../ResultModal'
import UserInfoTooltip from '../UserInfoTooltip'
import useStyles from './styles/AuditLogsFormListRow.styles'

interface AuditLogsFormListRowDesktopProps {
  data: Log
  actionNames: {
    label: string
    value: string
  }[]
  isRoleAdmin: boolean
}

const AuditLogsFormListRowDesktop: React.FC<
  AuditLogsFormListRowDesktopProps
> = ({ data, actionNames, isRoleAdmin }) => {
  const classes = useStyles()

  const [isContentModalOpen, setIsContentModalOpen] = useState(false)
  const [isResultModalOpen, setIsResultModalOpen] = useState(false)

  const label = actionNames.find((v) => v.value === data.action)?.label
  const actionLabel = label || data.action

  return (
    <div className={[classes.root, isRoleAdmin && classes.adminRoot].join(' ')}>
      <div>
        <Typography variant="body1">
          {lang === 'fa'
            ? gregorianToJalaaliWithHourMinuteAndSecondAndMilisecond(
                data.occurredAt
              )
            : data.occurredAt}
        </Typography>
      </div>
      {isRoleAdmin && (
        <div>
          <Typography variant="body1">{data.correlationID}</Typography>
        </div>
      )}
      <div>
        <UserInfoTooltip user={data.user} />
      </div>
      <div>
        <Tooltip title={actionLabel || ''} placement="top-start">
          <Typography variant="body1">
            {actionLabel?.substring(0, 20)}
            {actionLabel && actionLabel.length > 20 && '...'}
          </Typography>
        </Tooltip>
      </div>
      <div
        className={classes.hasModalCell}
        onClick={() => {
          setIsContentModalOpen(true)
        }}>
        <Typography variant="body1">{getTranslate('Show More')}</Typography>
        <ExpandMoreIcon />
      </div>
      <div>
        <Typography variant="body1">
          <StatusBox status={data.level === 'info' ? 'Success' : 'Error'} />
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          <StateBox status={data.isValidHash} />
        </Typography>
      </div>
      <div
        className={classes.hasModalCell}
        onClick={() => {
          setIsResultModalOpen(true)
        }}>
        <Typography variant="body1">{getTranslate('Show More')}</Typography>
        <ExpandMoreIcon />
      </div>
      {isContentModalOpen && (
        <ContentModal
          onClose={() => {
            setIsContentModalOpen(false)
          }}
          entities={data.entities}
          logContent={data.logContent}
        />
      )}
      {isResultModalOpen && (
        <ResultModal
          onClose={() => {
            setIsResultModalOpen(false)
          }}
          data={JSON.parse(data.response)}
        />
      )}
    </div>
  )
}
export default AuditLogsFormListRowDesktop
